import { Auth } from "./pages/auth";
import { Register } from "./pages/register";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { Navbar } from "./components/navbar";
import Message from "./pages/message";
import { app, auth } from "./config/firebase";
import { Profile } from "./pages/profile";
import { Footer } from "./components/footer";
import { ResetPassword } from "./components/resetPassword";
import DiscoveryPage from "./pages/discoveryPage";
import { About } from "./pages/about";
import { Pricing } from "./pages/pricing";
import { Terms } from "./pages/terms-of-service";
import { PrivacyPolicy } from "./pages/privacy-policy";
import { Confirmation } from "./pages/confirmation";
import { UserAccount } from "./pages/userAccount";
import { Subscription } from "./pages/Subscription";
import { NotificationsSettings } from "./pages/notificationsSettings";
import { BlockedUsers } from "./pages/blockedUsers";
import ReferralPage from "./pages/referral";
import ReferralSuccessPage from "./pages/referral-success";
import Admin from "./pages/admin";
import { initQuickPresence } from "./components/quickPresence";
import { useEffect, useState } from "react";
import { startPremiumStatusSync } from "./components/getPremiumStatus";

import RequireAuth from "./components/requireAuth";
import DemoPage from "./pages/Demo/demoPAge";
import { useAuthInitializer } from "./hooks/useAuthInitializer";
import { useInactivityLogout } from "./components/useInactivityLogout";
import HowToUse from "./pages/HowToUse/HowToUse";
import SubscriptionSuccessModal from "./components/SubscriptionSuccessModal";
import { useAuthState } from "react-firebase-hooks/auth";
import { useRealtimeNotifications } from "./components/useRealtimeNotifications";
import SupportDataDeletion from "./pages/supportDataDeletion/supportDataDeletion";
import ConfirmDeletion from "./pages/supportDataDeletion/confirmDeletion";
import { ChildSafety } from "./pages/child-safety";
import { CorruptedAccount } from "./pages/corruptedAccount";

function App() {
  useInactivityLogout();
  useAuthInitializer();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [user] = useAuthState(auth);
  useRealtimeNotifications({ userUid: user?.uid || null });
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("subscription_success")) {
      setShowSuccessModal(true);
    }
  }, []);

  useEffect(() => {
    initQuickPresence();
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get("ref");
    if (referralCode) {
      // Set a cookie that expires in 30 days
      const d = new Date();
      d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie =
        "referralCode=" + referralCode + ";" + expires + ";path=/";
    }
  }, []);

  useEffect(() => {
    const stop = startPremiumStatusSync(app);
    return () => stop();
  }, []);



  const protectedRoutes = (
    <>
      <Route path="/" element={<Navigate to="/discovery" />} />
      <Route path="/discovery" element={<RequireAuth><DiscoveryPage /></RequireAuth>} />
      <Route path="/profile/:uid" element={<RequireAuth><Profile /></RequireAuth>} />
      <Route path="/profile/edit/:uid" element={<RequireAuth><Profile /></RequireAuth>} />
      <Route path="/message/:mid" element={<RequireAuth><Message /></RequireAuth>} />
      <Route path="/account/:uid" element={<RequireAuth><UserAccount /></RequireAuth>} />
      <Route path="/subscription/:uid" element={<RequireAuth><Subscription /></RequireAuth>} />
      <Route path="/notificationsSettings/:uid" element={<RequireAuth><NotificationsSettings /></RequireAuth>} />
      <Route path="/blockedUsers/:uid" element={<RequireAuth><BlockedUsers /></RequireAuth>} />
      <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />
      <Route path="/corrupted-account" element={<RequireAuth><CorruptedAccount /></RequireAuth>} />
      {/* <Route path="/demo" element={<DemoPage />} /> */}
    </>
  );

  const publicRoutes = (
    <>
      <Route path="/" element={<About />} />
      <Route path="/about" element={<About />} />
      <Route path="/login" element={<Auth />} />
      <Route path="/register" element={<Register />} />
      {/* <Route path="/demo" element={<DemoPage />} /> */}
      <Route path="/resetPassword" element={<ResetPassword />} />
    </>
  );
  return (
    <div className="App">

      <Router>
        <SubscriptionSuccessModal
          isOpen={showSuccessModal}
          onRequestClose={() => setShowSuccessModal(false)}
        />
        <Navbar />
        <Routes>
          {/* Render conditional routes */}
          {user ? protectedRoutes : publicRoutes}

          {/* Static Global Routes (Pages anyone can see regardless of login) */}
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/terms-of-service" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/how-to-use" element={<HowToUse />} />
          <Route path="/referral" element={<ReferralPage />} />
          <Route path="/referral-success" element={<ReferralSuccessPage />} />
          <Route path="/data-deletion" element={<SupportDataDeletion />} />
          <Route path="/confirm-deletion" element={<ConfirmDeletion />} />
          <Route path="/child-safety" element={<ChildSafety />} />

          {/* Fallback redirect */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </Router>
      {/* OLD CODE:
      </Router>
      <Footer />
      */}
    </div>
  );
}

export default App;


// import { Auth } from "./pages/auth";
// import { Register } from "./pages/register";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { Navbar } from "./components/navbar";
// import Message from "./pages/message";
// import { app, auth } from "./config/firebase";
// import { Profile } from "./pages/profile";
// import { Footer } from "./components/footer";
// import { ResetPassword } from "./components/resetPassword";
// import DiscoveryPage from "./pages/discoveryPage";
// import { About } from "./pages/about";
// import { Pricing } from "./pages/pricing";
// import { Terms } from "./pages/terms-of-service";
// import { PrivacyPolicy } from "./pages/privacy-policy";
// import { Confirmation } from "./pages/confirmation";
// import { UserAccount } from "./pages/userAccount";
// import { Subscription } from "./pages/Subscription";
// import { NotificationsSettings } from "./pages/notificationsSettings";
// import { BlockedUsers } from "./pages/blockedUsers";
// import ReferralPage from "./pages/referral";
// import ReferralSuccessPage from "./pages/referral-success";
// import Admin from "./pages/admin";
// import { initQuickPresence } from "./components/quickPresence";
// import { useEffect, useState } from "react";
// import { startPremiumStatusSync } from "./components/getPremiumStatus";

// import RequireAuth from "./components/requireAuth";
// import DemoPage from "./pages/Demo/demoPAge";
// import { useAuthInitializer } from "./hooks/useAuthInitializer";
// import { useInactivityLogout } from "./components/useInactivityLogout";
// import HowToUse from "./pages/HowToUse/HowToUse";
// import SubscriptionSuccessModal from "./components/SubscriptionSuccessModal";
// import { useAuthState } from "react-firebase-hooks/auth";
// import { useRealtimeNotifications } from "./components/useRealtimeNotifications";


// function App() {
//   useInactivityLogout();
//   useAuthInitializer();
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [user] = useAuthState(auth);
//   useRealtimeNotifications({ userUid: user?.uid || null });
//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     if (urlParams.get("subscription_success")) {
//       setShowSuccessModal(true);
//     }
//   }, []);

//   useEffect(() => {
//     initQuickPresence();
//   }, []);

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const referralCode = urlParams.get("ref");
//     if (referralCode) {
//       // Set a cookie that expires in 30 days
//       const d = new Date();
//       d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
//       let expires = "expires=" + d.toUTCString();
//       document.cookie =
//         "referralCode=" + referralCode + ";" + expires + ";path=/";
//     }
//   }, []);

//   useEffect(() => {
//     const stop = startPremiumStatusSync(app);
//     return () => stop();
//   }, []);


//   return (
//     <div className="App">

//       <Router>
//         <SubscriptionSuccessModal
//           isOpen={showSuccessModal}
//           onRequestClose={() => setShowSuccessModal(false)}
//         />
//         <Navbar />
//         <Routes>
//           <Route path="/" element={<About />} />
//           <Route path="/register" element={<Register />} />
//           <Route path="/demo" element={<DemoPage />} />
//           <Route
//             path="/profile/:uid"
//             element={
//               <RequireAuth>
//                 <Profile />
//               </RequireAuth>
//             }
//           />
//           <Route
//             path="/profile/edit/:uid"
//             element={
//               <RequireAuth>
//                 <Profile />
//               </RequireAuth>
//             }
//           />
//           <Route
//             path="/message/:mid"
//             element={
//               <RequireAuth>
//                 <Message />
//               </RequireAuth>
//             }
//           />
//           <Route path="/resetPassword" element={<ResetPassword />} />
//           <Route
//             path="/discovery"
//             element={
//               <RequireAuth>
//                 <DiscoveryPage />
//               </RequireAuth>
//             }
//           />
//           <Route path="/login" element={<Auth />} />
//           <Route
//             path="/account/:uid"
//             element={
//               <RequireAuth>
//                 <UserAccount />
//               </RequireAuth>
//             }
//           />
//           <Route path="/pricing" element={<Pricing />} />
//           <Route path="/terms-of-service" element={<Terms />} />
//           <Route path="/confirmation" element={<Confirmation />} />
//           <Route path="/how-to-use" element={<HowToUse />} />
//           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//           <Route
//             path="/subscription/:uid"
//             element={
//               <RequireAuth>
//                 <Subscription />
//               </RequireAuth>
//             }
//           />
//           <Route
//             path="/notificationsSettings/:uid"
//             element={
//               <RequireAuth>
//                 <NotificationsSettings />
//               </RequireAuth>
//             }
//           />
//           <Route
//             path="/blockedUsers/:uid"
//             element={
//               <RequireAuth>
//                 <BlockedUsers />
//               </RequireAuth>
//             }
//           />
//           <Route path="/referral" element={<ReferralPage />} />
//           <Route path="/referral-success" element={<ReferralSuccessPage />} />
//           <Route
//             path="/admin"
//             element={
//               <RequireAuth>
//                 <Admin />
//               </RequireAuth>
//             }
//           />
//         </Routes>
//       </Router>
//       <Footer />
//     </div>
//   );
// }

// export default App;

// // E:\vscode\gitHub\flintt-25-10-29\src\pages\profile.jsx
